import Vue from 'vue';

/**
 * environment
 * @function getAppId
 * @function getAppName
 * @function getSponsorId
 * @function getApiUrl
 * @function getApiModuleUrl
 * @function getBlobUrl
 * @function getMiscUrl
 * @function getShoppingCartUrl
 * @function getShippingUrl
 * api config str
 * @function getCampaignConfig
 * @function getDashboardConfig
 * @function getCategoryConfig
 * @function getSubscriptionConfig
 * @function getHistoryConfig
 * setting
 * @function getCacheType
 * custom
 * @function getCampaignListDevApp
 * @function getCategoryMenu
 * @function getSubscriptionMenu
 * @function getAgencyId
 */
export default {
    //#region normal environment
    getAppId: function() {
        return Vue.bzbsConfig.client_id;
    },
    getAppName: function () {
        return Vue.bzbsConfig.appname;
    },
    getSponsorId: function () {
        return Vue.bzbsConfig.sponsor_id;
    },
    getApiUrl: function() {
        return Vue.bzbsConfig.bzbsUrl;
    },
    getApiUrlwallet: function() {
        return Vue.bzbsConfig.bzbsUrlWallet;
    },
    getApiModuleUrl: function () {
        return Vue.bzbsConfig.bzbsModuleUrl;
    },
    getApiShoppingUrl: function () {
        return Vue.bzbsConfig.webShoppingCartUrl;
    },
    getBlobUrl: function() {
        return Vue.bzbsConfig.bzbsBlobUrl;
    },
    getMiscUrl: function() {
        return Vue.bzbsConfig.miscUrl;
    },
    getApiShoppingCartUrl: function () {
        return Vue.bzbsConfig.apiShoppingCartUrl;
    },
    getShoppingCartUrl: function() {
        return Vue.bzbsConfig.webShoppingCartUrl;
    },
    getShippingUrl: function() {
        return Vue.bzbsConfig.apiShippingUrl;
    },
    //#endregion normal environment

    //#region config str
    getCampaignConfig: function() {
        return Vue.bzbsConfig.campaignConfig;
    },
    getDashboardConfig: function() {
        return Vue.bzbsConfig.dashboardConfig;
    },
    getCategoryConfig: function() {
        return Vue.bzbsConfig.categoryConfig;
    },
    getSubscriptionConfig: function() {
        return Vue.bzbsConfig.SubscriptionConfig;
    },
    getSubscriptionItemConfig: function() {
        return Vue.bzbsConfig.SubscriptionItemConfig;
    },
    getAddonConfig: function() {
        return Vue.bzbsConfig.addonConfig;
    },
    getUpsizeConfig: function() {
        return Vue.bzbsConfig.upsizeConfig;
    },
    getHistoryConfig: function() {
        return Vue.bzbsConfig.historyConfig;
    },
    //#endregion config str

    //#region setting
    getCacheType: function() {
        return Vue.bzbsConfig.setting.cache;
    },
    getAddressType: function() {
        return Vue.bzbsConfig.setting.addressType;
    },
    //#endregion setting

    //#region custom
    getCampaignListDevApp: function() {
        return this.getCampaignConfig().campaignListConfig;
    },
    getCategoryMenu: function() {
        return this.getCategoryConfig().menuCategory;
    },
    getSubscriptionMenu: function() {
        return this.getSubscriptionConfig().menuCategory;
    },
    getSubscriptionItem: function() {
        return this.getSubscriptionItemConfig().menuCategory;
    },
    getAddon: function() {
        return this.getAddonConfig().menuCategory;
    },
    getUpsize: function() {
        return this.getUpsizeConfig().menuCategory;
    },
    getHistoryPurchaseList: function() {
        return this.getHistoryConfig().purchase;
    },
    getAgencyId: function() {
        return Vue.bzbsConfig.agency_id;
    }
    //#endregion custom
};
